(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cxk-football-finder"] && !Shopify.designMode) return;
  try {
    
  const initializeFootballFinder = (section) => {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const source = section.querySelector('[data-product-source]');
    const grid = section.querySelector('[data-team-grid]');
    const search = section.querySelector('.cxk-football__search');
    const clear = section.querySelector('.cxk-football__clear');
    const empty = section.querySelector('[data-empty]');
    const showAll = section.querySelector('[data-show-all]');
    const count = section.querySelector('[data-results-count]');
    const title = section.querySelector('[data-results-title]');
    const kicker = section.querySelector('[data-results-kicker]');
    const pills = section.querySelector('[data-team-pills]');
    const popularLimit = Number(section.dataset.popularLimit) || 8;
    const teams = new Map();

    source.querySelectorAll('quick-add-modal').forEach((modal) => {
      document.body.appendChild(modal);
    });

    source.querySelectorAll('.cxk-football-product').forEach((product) => {
      const key = product.dataset.teamKey;
      if (!teams.has(key)) teams.set(key, { key, name: product.dataset.team, products: [] });
      teams.get(key).products.push(product);
    });

    const teamList = Array.from(teams.values());
    teamList.forEach((team, index) => {
      team.products.sort((a, b) => Number(a.dataset.caseOrder) - Number(b.dataset.caseOrder));
      const card = document.createElement('article');
      card.className = 'cxk-football-team';
      card.dataset.teamKey = team.key;
      card.dataset.teamName = team.name.toLowerCase();
      card.dataset.rank = String(index);
      card.innerHTML = `<header class="cxk-football-team__header"><h3></h3><span></span></header><div class="cxk-football-team__types"></div>`;
      card.querySelector('h3').textContent = team.name;
      card.querySelector('header span').textContent = `${team.products.length} case ${team.products.length === 1 ? 'type' : 'types'}`;
      const types = card.querySelector('.cxk-football-team__types');
      team.products.forEach((product) => types.appendChild(product));
      team.card = card;
      grid.appendChild(card);
    });

    source.remove();

    teamList.slice(0, popularLimit).forEach((team) => {
      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'cxk-football__pill';
      pill.textContent = team.name;
      pill.addEventListener('click', () => {
        search.value = team.name;
        applyFilter();
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      pills.appendChild(pill);
    });

    function applyFilter(showEverything = false) {
      const query = search.value.trim().toLowerCase();
      let visible = 0;
      teamList.forEach((team, index) => {
        const matches = !query || team.name.toLowerCase().includes(query);
        const shouldShow = matches && (query || showEverything || index < popularLimit);
        team.card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });

      clear.hidden = !query;
      empty.hidden = visible !== 0;
      showAll.hidden = Boolean(query) || showEverything || teamList.length <= popularLimit;
      count.textContent = query
        ? (visible ? `${visible} ${visible === 1 ? 'team' : 'teams'} found` : '')
        : `${teamList.length} teams available`;
      title.textContent = query ? `Results for “${search.value.trim()}”` : (showEverything ? 'Every team' : 'Shop by team');
      kicker.textContent = query ? 'Team search' : (showEverything ? 'Full football collection' : 'Most popular');
    }

    let searchTimer;
    search.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => applyFilter(), 80);
    });
    clear.addEventListener('click', () => {
      search.value = '';
      search.focus();
      applyFilter();
    });
    showAll.addEventListener('click', () => applyFilter(true));
    applyFilter();
  };

  const initializeFootballFinders = (root = document) => {
    root.querySelectorAll('.cxk-football').forEach(initializeFootballFinder);
  };

  initializeFootballFinders();
  document.addEventListener('shopify:section:load', (event) => initializeFootballFinders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cxk-squishy-fun-box"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-sfb-root]').forEach((section)=>{if(section.dataset.ready==='true')return;section.dataset.ready='true';const track=section.querySelector('[data-sfb-track]');const slides=[...section.querySelectorAll('[data-sfb-slide]')];const thumbs=[...section.querySelectorAll('[data-sfb-thumb]')];const counter=section.querySelector('[data-sfb-current]');let active=0;const show=(index)=>{if(!slides.length)return;active=(index+slides.length)%slides.length;slides[active].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===active));if(counter)counter.textContent=active+1};section.querySelector('[data-sfb-prev]')?.addEventListener('click',()=>show(active-1));section.querySelector('[data-sfb-next]')?.addEventListener('click',()=>show(active+1));thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));if(track&&slides.length){let frame;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const index=Math.round(track.scrollLeft/track.clientWidth);if(index!==active&&slides[index]){active=index;thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===active));if(counter)counter.textContent=active+1}})},{passive:true})}const quantity=section.querySelector('[data-sfb-quantity]');const button=section.querySelector('[data-sfb-atc]');const prices={};section.querySelectorAll('.sfb__offer input').forEach((input)=>{prices[input.value]=input.closest('.sfb__offer')?.querySelector('.sfb__offer-price strong')?.textContent;input.addEventListener('change',()=>{section.querySelectorAll('.sfb__offer').forEach((offer)=>offer.classList.toggle('is-selected',offer.contains(input)));if(quantity)quantity.value=input.value;if(button)button.textContent=button.dataset.label||'ADD TO CART'})});const videoTrack=section.querySelector('[data-sfb-video-track]');if(videoTrack){const step=()=>{const card=videoTrack.querySelector('[data-sfb-video-card]');return card?card.getBoundingClientRect().width+12:videoTrack.clientWidth};section.querySelector('[data-sfb-video-prev]')?.addEventListener('click',()=>videoTrack.scrollBy({left:-step(),behavior:'smooth'}));section.querySelector('[data-sfb-video-next]')?.addEventListener('click',()=>videoTrack.scrollBy({left:step(),behavior:'smooth'}));videoTrack.querySelectorAll('video').forEach((video)=>video.addEventListener('play',()=>videoTrack.querySelectorAll('video').forEach((other)=>{if(other!==video)other.pause()})))}});
document.querySelectorAll('[data-sfb-root]').forEach((section) => {
  const form = section.querySelector('.sfb__form');
  const submitButton = form?.querySelector('[type="submit"]');
  const errorNode = section.querySelector('[data-sfb-form-error]');
  if (!form || form.dataset.cxkAjaxCart === 'true') return;
  form.dataset.cxkAjaxCart = 'true';
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!submitButton || submitButton.disabled) return;
    submitButton.disabled = true;
    submitButton.classList.add('loading');
    if (errorNode) errorNode.hidden = true;
    const body = new FormData(form);
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
      if (typeof window.CXK_openShrineCart === 'function') {
        window.CXK_openShrineCart(result);
      } else {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }
    } catch (error) {
      if (errorNode) {
        errorNode.textContent = error.message || errorNode.textContent;
        errorNode.hidden = false;
      }
    } finally {
      submitButton.disabled = false;
      submitButton.classList.remove('loading');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
